/**
 * Code Block — Prism.js syntax highlighting + clipboard copy button.
 *
 * Prism highlights every <code class="language-*"> element on the page.
 * Each .code-block__copy button reads its sibling <code> text and writes it
 * to the clipboard, then toggles the button to the "Copied" state for 2 s.
 */

import Prism from 'prismjs';
import 'prismjs/components/prism-markup';      // HTML / XML
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-markup-templating'; // required by prism-php
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-bash';
import 'prismjs/components/prism-json';

export default function initCodeBlocks() {
    const windows = document.querySelectorAll( '.code-block__window' );
    if ( ! windows.length ) return;

    // Highlight all code elements on the page.
    Prism.highlightAll();

    windows.forEach( function ( win ) {
        const btn  = win.querySelector( '.code-block__copy' );
        const code = win.querySelector( 'code' );

        if ( ! btn || ! code ) return;

        btn.addEventListener( 'click', function () {
            const text = code.textContent;

            function showCopied() {
                btn.classList.add( 'is-copied' );
                btn.querySelector( '.code-block__copy-done' ).removeAttribute( 'aria-hidden' );
                btn.querySelector( '.code-block__copy-idle' ).setAttribute( 'aria-hidden', 'true' );

                setTimeout( function () {
                    btn.classList.remove( 'is-copied' );
                    btn.querySelector( '.code-block__copy-done' ).setAttribute( 'aria-hidden', 'true' );
                    btn.querySelector( '.code-block__copy-idle' ).removeAttribute( 'aria-hidden' );
                }, 2000 );
            }

            if ( navigator.clipboard ) {
                // Secure context (HTTPS / localhost)
                navigator.clipboard.writeText( text ).then( showCopied );
            } else {
                // Fallback for HTTP (e.g. local dev without HTTPS)
                const ta = document.createElement( 'textarea' );
                ta.value = text;
                ta.style.cssText = 'position:fixed;top:0;left:0;opacity:0;';
                document.body.appendChild( ta );
                ta.focus();
                ta.select();
                try { document.execCommand( 'copy' ); showCopied(); } catch ( e ) {}
                document.body.removeChild( ta );
            }
        } );
    } );
}
